import React, { Fragment } from "react";
import { Corporation, CategoryTag, Locale } from "../../core/api/model";
import { DashboardFavouritesCorporationsListItem, DashboardFavouritesListEmpty } from ".";

export interface DashboardFavouritesCorporationsListProps {
  locale: Locale;
  corporations: Corporation[];
  deleteFavourite: (elementId: number, categoryTag: CategoryTag) => void;
}

export const DashboardFavouritesCorporationsList = (props: DashboardFavouritesCorporationsListProps) => {
  return props.corporations.length > 0 ? (
    // list
    <Fragment>
      {props.corporations.map((corporation: Corporation) =>
        <DashboardFavouritesCorporationsListItem key={corporation.corpId}
                                                locale={props.locale}
                                                corporation={corporation}
                                                deleteFavourite={props.deleteFavourite}
        />
      )}
    </Fragment>
  ) :
  // empty
  <DashboardFavouritesListEmpty />
};
